// Mutations
export const SET_OVERVIEW = (state, { key, value }) => {
  if (key && value) {
    state.overview.data = {
      ...state.overview.data,
      [key]: value,
    }

    state.overview.lastUpdate = {
      ...state.overview.lastUpdate,
      [key]: new Date(),
    }
  }
}
export const ADD_OVERVIEW = (state, { key, value }) => {
  if (!state.overview.data || typeof state.overview.data !== 'object') {
    state.overview.data = {}
  }

  if (!state.overview.data[key]) {
    state.overview.data = {
      ...state.overview.data,
      [key]: [],
    }
  }

  const arr = state.overview.data[key]
  let dados = JSON.parse(JSON.stringify(value))
  if (!Array.isArray(dados)) {
    dados = [dados]
  }

  dados.forEach((data) => {
    const old = arr.find((item) => item.id === data.id)
    if (old) {
      Object.keys(data).forEach((k) => {
        old[k] = data[k]
      })
    } else {
      arr.push(data)
    }
  })
}
export const SET_OVERVIEW_LOADING = (state, payload) => {
  state.overview.loading = payload
}
export const CLEAR_OVERVIEW = (state) => {
  state.overview.data = {}
  state.overview.lastUpdate = {}
  state.overview.loading = false
}

export const SET_MESES = (state, payload) => {
  state.meses.data = Array.isArray(payload) ? payload : []
  state.meses.lastUpdate = new Date()
}
export const SET_MESES_LOADING = (state, payload) => {
  state.meses.loading = payload
}
export const CLEAR_MESES = (state) => {
  state.meses.data = []
  state.meses.lastUpdate = null
  state.meses.loading = false
}

// `payload` = value de GET btg/disponivel: { disponivel, estorno_habilitado }.
export const SET_BTG_DISPONIVEL = (state, payload) => {
  const v = payload || {}
  state.btg.disponivel = Boolean(v.disponivel)
  state.btg.estornoHabilitado = Boolean(v.estorno_habilitado)
}
export const SET_BTG_CONEXAO = (state, payload) => {
  state.btg.conexao = payload && typeof payload === 'object' ? payload : null
}
export const SET_BTG_OPERACOES = (state, { key, value }) => {
  if (!key) return
  state.btg.operacoes = {
    ...state.btg.operacoes,
    [key]: Array.isArray(value) ? value : [],
  }
}
export const SET_BTG_SALDOS = (state, { saldos, consultadoEm }) => {
  state.btg.saldos = saldos && typeof saldos === 'object' ? saldos : {}
  state.btg.saldosConsultadoEm = consultadoEm || null
}
export const CLEAR_BTG = (state) => {
  state.btg.disponivel = null
  state.btg.estornoHabilitado = false
  state.btg.conexao = null
  state.btg.operacoes = {}
  state.btg.saldos = {}
  state.btg.saldosConsultadoEm = null
}
